import React from "react";

const Required = () => {
  return <span className="text-red-500 pl-1">*</span>;
};

export default Required;
